import { render, staticRenderFns } from "./TableTpl.vue?vue&type=template&id=109a8375&scoped=true&"
import script from "./TableTpl.vue?vue&type=script&lang=js&"
export * from "./TableTpl.vue?vue&type=script&lang=js&"
import style0 from "./TableTpl.vue?vue&type=style&index=0&id=109a8375&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109a8375",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
